export default "__VITE_ASSET__BDq8J0pz__"